/*
  groom.bg mixing helper (blocks/groom-mix.liquid): pet size → ml of product + water for one bath or a mixing
  bottle. All maths via window.GroomCalc (assets/groom-calc-core.js), the same rules as the bath-cost calculator
  and the shop assistant (shared fixture). Shows nothing when the rules give no figure.
*/
(() => {
  if (customElements.get('groom-mix')) return;

  class GroomMix extends HTMLElement {
    connectedCallback() {
      if (!window.GroomCalc) return; // core not loaded: stay hidden rather than guess
      try { this.cfg = JSON.parse(this.querySelector('[data-mix-cfg]').textContent); } catch (e) { return; }
      const rtuAttr = this.dataset.rtu;
      this.rtu = rtuAttr === 'true' ? true : rtuAttr === 'false' ? false : null;
      this.raw = this.dataset.raw || null;
      try { this.usage = JSON.parse(this.dataset.usage || 'null'); } catch (e) { this.usage = null; }
      const d = window.GroomCalc.decide(this.raw, this.rtu);
      if (!d.figures.length) return;
      this.hasDilute = d.figures.some((f) => f.kind === 'dilute');
      this.mode = 'bath';
      this.pet = (this.querySelector('[data-pet][aria-checked="true"]') || this.querySelector('[data-pet]')).dataset.pet;
      this.fromSavedPet();
      this.querySelector('[data-modes]').hidden = !this.hasDilute;
      this.addEventListener('click', (e) => {
        const b = e.target.closest('button');
        if (!b) return;
        if (b.dataset.pet) this.pet = b.dataset.pet;
        else if (b.dataset.mode) this.mode = b.dataset.mode;
        else return;
        this.render();
      });
      this.hidden = false;
      this.render();
    }

    // the shopper's saved pet ("Моите любимци"), when the theme exposes it
    fromSavedPet() {
      const p = typeof window.groomActivePet === 'function' ? window.groomActivePet() : null;
      if (!p) return;
      let want = p.species === 'cat' ? 'cat' : p.size || (p.weight ? (p.weight < 10 ? 'small' : p.weight <= 25 ? 'medium' : 'large') : null);
      if (want && this.querySelector(`[data-pet="${want}"]`)) this.pet = want;
    }

    t(k, vars) { return String(this.cfg.t[k] || k).replace(/\{(\w+)\}/g, (m, v) => (vars && vars[v] != null ? vars[v] : m)); }
    num(x, d) { return new Intl.NumberFormat(this.cfg.locale === 'bg' ? 'bg-BG' : 'en-GB', { maximumFractionDigits: d }).format(x); }
    // product: whole ml (1 decimal under 10 ml); water: 5 ml steps
    ml(x) { return x < 10 ? this.num(Math.round(x * 10) / 10, 1) : this.num(Math.round(x), 0); }
    water(x) { return this.num(Math.round(x / 5) * 5, 0); }

    render() {
      this.querySelectorAll('[data-pet]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.pet === this.pet)));
      this.querySelectorAll('[data-mode]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.mode === this.mode)));
      // maker-stated groom.usage wins, else the default table (no coat input here: long_factor not applied)
      const C = window.GroomCalc, def = { ready: this.cfg.ready, neat: this.cfg.neat, long_factor: 1 };
      const ar = C.amount(this.usage, this.pet, false, 'dilute', def), an = C.amount(this.usage, this.pet, false, 'as_sold', def);
      const amounts = this.mode === 'bath' ? { solution_ml: ar.ml, neat_ml: an.ml } : { bottle_ml_target: +this.mode };
      const r = window.GroomCalc.compute(this.raw, this.rtu, amounts, null);
      const rows = r.figures.map((f) => {
        const label = f.kind === 'as_sold' ? this.t('neat') : this.t(f.limit ? 'diluted_upto' : 'diluted', { n: this.num(f.n, 1) });
        let line;
        if (f.product_ml == null) line = this.t('nothing_to_mix');
        else if (f.kind === 'as_sold') line = this.t('neat_line', { p: this.ml(f.product_ml) });
        else line = this.t('product_water', { p: this.ml(f.product_ml), w: this.water(f.water_ml) });
        const src = this.mode === 'bath' && f.product_ml != null ? (f.kind === 'dilute' ? ar.source : an.source) : null;
        return `<li><small>${label}${src ? ` · ${this.t('src_' + src)}` : ''}</small><b>${line}</b></li>`;
      });
      this.querySelector('[data-rows]').innerHTML = rows.join('');
      const notes = [];
      if (r.figures.length > 1 && r.mode === 'both') notes.push(this.t('both_note'));
      if (this.mode === 'bath') {
        const used = r.figures.filter((f) => f.product_ml != null).map((f) => (f.kind === 'dilute' ? ar.source : an.source));
        if (used.includes('default')) notes.push(this.t('note', { pet: this.t(`pet_${this.pet}`) }));
        else if (used.length) notes.push(this.t('note_maker'));
      }
      this.querySelector('[data-note]').textContent = notes.join(' ');
    }
  }
  customElements.define('groom-mix', GroomMix);
})();
